import { IUserPhoto } from '../Stores/UserPhotoStore';
import { ApiService } from '../_services/ApiService';

export interface IPhotoInfo {
    photo_id: number;
    added_at: Date;
    removed_at?: any;
}

export interface IStoryFromServer {
    title: string;
    family_id: number;
    id: number;
    created_at: string;
    user_id: number;
    photo_infos: Array<IPhotoInfo>;
}

export class StoryServices extends ApiService {
    protected basePath = 'collections';
    protected subPaths = {
        forPhotos: (id: number) => `${id}/photos`,
        forPhotosOrder: (id: number) => `${id}/photos/order`,
        forPhotoComments: (collectionID: number, photoID: number) => `${collectionID}/photos/${photoID}/comments`,
        commentCount: (id: number) => `${id}/comments/count`,
        forID: (id: number) => `${id}`
    };

    public getAllStories(): Promise<Array<IStoryFromServer>> {
        return this.getRequest().then(response => {
            const stories = response as Array<IStoryFromServer>;

            return stories;
        });
    }

    public getStoryByID(id: number): Promise<Array<IStoryFromServer>> {
        return this.getSubPath(this.subPaths.forID(id));
    }

    public updateStoryTitle(id: number, title: string): Promise<void> {
        return this.putSubPath(this.subPaths.forID(id), { title });
    }

    public updateFamilyShare(family_id: number | undefined, storyID: number): Promise<void> {
        return this.putSubPath(this.subPaths.forID(storyID), { family_id });
    }

    public addPhotosToStory(id: number, photo_ids: Array<number>): Promise<void> {
        return this.postSubPath(this.subPaths.forPhotos(id), {photo_ids});
    }

    public reOrderPhotosInStory(id: number, photo_ids: Array<number>): Promise<void> {
        return this.putSubPath(this.subPaths.forPhotosOrder(id), {order: photo_ids});
    }

    public removePhotoFromCollection(id: number, photo_id: number): Promise<void> {
        return this.deleteSubPath(this.subPaths.forPhotos(id), { photo_id });
    }

    public getStoriesForPhotoID(photoID: number): Promise<Array<IStoryFromServer>> {
        return this.getRequest({ photo_id: photoID });
    }

    public getCommentsForPhotoInCollection(collectionID: number, photoID: number): Promise<void> {
        return this.getSubPath(this.subPaths.forPhotoComments(collectionID, photoID)).then(response => {
            return response;
        });
    }

    public getAllPhotosForStory(storyID: number): Promise<Array<IUserPhoto>> {
        return this.getSubPath(this.subPaths.forPhotos(storyID));
    }

    public createStory(title: string, family_id?: number): Promise<IStoryFromServer> {
        return this.postRequest({ title, family_id });
    }

    public deleteStory(storyID: number): void {
        this.deleteSubPath(`${storyID}`);
    }

    public getCommentCountForStory(storyID: number): Promise<number> {
        return this.getSubPath(this.subPaths.commentCount(storyID));
    }
}



// WEBPACK FOOTER //
// ./src/Services/StoryService.ts